import React, { createContext, useContext, useState } from 'react';
import {
  RegisterFormData,
  EnderecoData,
  ResponsavelData,
  NegocioData,
  ExplicacaoData,
  CategoryData,
  LoginData,
} from '../types/RegisterType';

interface RegisterContextValue {
  formData: RegisterFormData;
  updateEndereco: (data: EnderecoData) => void;
  updateResponsavel: (data: ResponsavelData) => void;
  updateNegocio: (data: NegocioData) => void;
  updateExplicacao: (data: ExplicacaoData) => void;
  updateCategory: (data: CategoryData) => void;
  updateLogin: (data: LoginData) => void;
}

const initialFormData: RegisterFormData = {
  endereco: { cep: '', rua: '', numero: '', complemento: '', bairro: '', cidade: '', uf: '' },
  responsavel: { nomeCompleto: '', cpf: '', telefone: '', email: '' },
  negocio: { nomePetshop: '', cnpj: '', razaoSocial: '', telefone: '' },
  explicacao: { entendi: false },
  category: {},
  login: { email: '', password: '', confirmPassword: '' },
};

const RegisterContext = createContext<RegisterContextValue | undefined>(undefined);

export const RegisterProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [formData, setFormData] = useState<RegisterFormData>(initialFormData);

  const updateEndereco = (data: EnderecoData) =>
    setFormData(prev => ({ ...prev, endereco: data }));

  const updateResponsavel = (data: ResponsavelData) =>
    setFormData(prev => ({ ...prev, responsavel: data }));

  const updateNegocio = (data: NegocioData) =>
    setFormData(prev => ({ ...prev, negocio: data }));

  const updateExplicacao = (data: ExplicacaoData) =>
    setFormData(prev => ({ ...prev, explicacao: data }));

  const updateCategory = (data: CategoryData) =>
    setFormData(prev => ({ ...prev, category: data }));

  const updateLogin = (data: LoginData) =>
    setFormData(prev => ({ ...prev, login: data }));

  return (
    <RegisterContext.Provider
      value={{
        formData,
        updateEndereco,
        updateResponsavel,
        updateNegocio,
        updateExplicacao,
        updateCategory,
        updateLogin,
      }}
    >
      {children}
    </RegisterContext.Provider>
  );
};

export const useRegister = (): RegisterContextValue => {
  const context = useContext(RegisterContext);
  if (!context) {
    throw new Error('useRegister must be used within a RegisterProvider');
  }
  return context;
};
